export function getAcquisitionCountryMetadataFromSearch(search = "") {
  const value = new URLSearchParams(search || "").get("acquisition_country");
  const country = typeof value === "string" ? value.trim().toUpperCase() : "";
  return /^[A-Z]{2}$/.test(country) ? { acquisition_country: country } : {};
}
